import { useTranslation } from "react-i18next";
import { useWizard } from "../../../components/Wizard/Wizard";
import WelcomeStep from "../WelcomeStep";

export default function WelcomeAllergologyStep() {
  const { t } = useTranslation();
  const { goToNextStep } = useWizard();

  return (
    <WelcomeStep
      confirmation={t("pages.booking.allergology.steps.welcome.form.confirm")}
      instructionKey="pages.booking.allergology.steps.welcome.instructions"
      onSubmit={goToNextStep}
      title={t("pages.booking.allergology.steps.welcome.title")}
    />
  );
}
